import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const PostCodeHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="post_code" t={t}>
      <Box mb={3}>
        <H3>Postleitzahl</H3>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Die Postleitzahl ist für den Prüfprozess nötig, um die
          <b>Wirtschaftlichkeit des Vermieters</b>
          zu prüfen. Diese unterscheidet sich je nach Region stark. Liegen Ihre Kosten im regionalen Durchschnitt? Oder
          zahlen Sie eventuell deutlich mehr?
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Des Weiteren ist die Postleitzahl für die
          <b>Wartung der Rauchwarnmelder</b>
          nötig. Diese darf in manchen Regionen auf den Mieter umgelegt werden, in anderen jedoch nur nach
          mietvertraglicher Vereinbarung. Hat ihr Vermieter sich an die gesetzlichen Vorgaben gehalten?
        </Subtitle>
      </Box>
      <Box mb={2}>
        <Subtitle>Als letztes benötigen wir Ihre Postleitzahl für die Erstellung der Rechnung.</Subtitle>
      </Box>
    </Trans>
  );
};
export default PostCodeHelp;
